import { storedLanguage, translations } from '../services/i18n/translation.service';

/** index.html's start-up shell (P8): a brand mark and a spinner until the first page settles. */
const SHELL_ID = 'app-shell';
/** Nothing settled by then: the start has stalled, so the shell offers Reload. */
export const APP_SHELL_STALL_MS = 20_000;

/** The first page settled: the shell goes, unless it already says the app could not load. */
export function removeAppShell(doc: Document): void {
  const shell = doc.getElementById(SHELL_ID);
  if (!shell || shell.dataset['failed'] !== undefined) return;
  shell.remove();
  doc.querySelector('app-root')?.removeAttribute('inert');
}

/**
 * The app could not start: the shell says so with a Reload button, in the stored language,
 * instead of spinning forever. False when the shell is already gone.
 */
export function showAppShellError(doc: Document): boolean {
  const shell = doc.getElementById(SHELL_ID);
  const status = doc.getElementById('app-shell-status');
  if (!shell || !status) return false;
  // Runs before DI exists (bootstrap failure), so the texts are read directly
  const texts = translations[storedLanguage()];
  const line = doc.createElement('p');
  line.className = 'text-[15px] text-gray-900';
  line.textContent = texts['app.loadFailed'];
  const reload = doc.createElement('button');
  reload.type = 'button';
  reload.className =
    'h-11 rounded-lg bg-accent px-5 text-[15px] font-semibold text-black hover:bg-accent-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2';
  reload.textContent = texts['app.reload'];
  reload.addEventListener('click', () => doc.defaultView?.location.reload());
  status.replaceChildren(line, reload);
  shell.dataset['failed'] = '';
  shell.removeAttribute('aria-busy');
  reload.focus();
  return true;
}

/** Started with the bootstrap: a start that never settles ends on the error, not a spinner. */
export function watchAppShell(doc: Document): void {
  setTimeout(() => showAppShellError(doc), APP_SHELL_STALL_MS);
}
